// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";
import * as V3ClozeChoiceProvider$LiteracyplanetTupperware from "./V3ClozeChoiceProvider.res.mjs";

var overClassName = "pilotClozeDropSingleOverClassName";

var dropClassName = "pilotClozeDropSingleDroppedClassName";

function renderDragOverlayComponent(children) {
  return React.createElement("div", {
              className: "pilotClozeSingleOverlayItem"
            }, children);
}

function renderDroppedComponent(onClick, children) {
  return React.createElement("button", {
              className: "pilotClozeSingleDroppedItemOriginalCopy",
              onClick: onClick
            }, children);
}

function renderCorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeChoiceProviderCorrect",
              onClick: onClick
            }, React.createElement("div", {
                  className: "pilotClozeChoiceProviderMarkContainer"
                }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                      className: "pilotClozeChoiceProviderTickSvg"
                    })), children);
}

function renderIncorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeChoiceProviderIncorrect",
              onClick: onClick
            }, React.createElement("div", {
                  className: "pilotClozeChoiceProviderMarkContainer"
                }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                      className: "pilotClozeChoiceProviderCrossSvg"
                    })), children);
}

function renderDragComponent(onClick, children) {
  return React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
              layout: true,
              children: Caml_option.some(children)
            });
}

function PilotClozeChoiceProvider$Reveal(props) {
  var match = V3RevealApi$LiteracyplanetTupperware.use();
  return props.children(match.reveal);
}

var Reveal = {
  make: PilotClozeChoiceProvider$Reveal
};

function renderAlreadyDraggedAndMarkedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeChoiceProvider$Reveal, {
              children: (function (reveal) {
                  switch (reveal) {
                    case "DontHideItems" :
                        return React.createElement("div", {
                                    className: "pilotClozeSingleDroppedItemOriginalCopy",
                                    onClick: onClick
                                  }, children);
                    case "Hide" :
                    case "RevealOneAtATime" :
                        return null;
                    
                  }
                })
            });
}

function renderAlreadyDraggedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeChoiceProvider$Reveal, {
              children: (function (reveal) {
                  switch (reveal) {
                    case "DontHideItems" :
                        return React.createElement("div", {
                                    className: "pilotClozeSingleDroppedItemOriginalCopy cursor-pointer",
                                    onClick: onClick
                                  }, children);
                    case "Hide" :
                    case "RevealOneAtATime" :
                        return null;
                    
                  }
                })
            });
}

function renderUndroppedMarkedComponent(onClick, children) {
  return React.createElement("div", {
              className: "pilotClozeDragBucketItem"
            }, children);
}

function PilotClozeChoiceProvider(props) {
  return React.createElement(V3RevealApi$LiteracyplanetTupperware.Provider.make, {
              value: {
                reveal: "Hide"
              },
              children: React.createElement(V3ClozeChoiceProvider$LiteracyplanetTupperware.make, {
                    overClassName: overClassName,
                    dropClassName: dropClassName,
                    renderDragComponent: renderDragComponent,
                    renderDragOverlayComponent: renderDragOverlayComponent,
                    renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
                    renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
                    renderDroppedComponent: renderDroppedComponent,
                    renderCorrectDroppedComponent: renderCorrectDroppedComponent,
                    renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
                    renderUndroppedMarkedComponent: renderUndroppedMarkedComponent,
                    questionIndex: props.questionIndex,
                    children: props.children
                  })
            });
}

var Motion;

var make = PilotClozeChoiceProvider;

var $$default = PilotClozeChoiceProvider;

export {
  Motion ,
  overClassName ,
  dropClassName ,
  renderDragOverlayComponent ,
  renderDroppedComponent ,
  renderCorrectDroppedComponent ,
  renderIncorrectDroppedComponent ,
  renderDragComponent ,
  Reveal ,
  renderAlreadyDraggedAndMarkedPlaceholder ,
  renderAlreadyDraggedPlaceholder ,
  renderUndroppedMarkedComponent ,
  make ,
  $$default as default,
}
/* react Not a pure module */
